import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import axios from "axios";

const firebaseConfig = {
  apiKey: "AIzaSyAB74YbVP813jO6Eg_XddxMmLleuAfwl-I",
  authDomain: "ingressodahora-9bbe9.firebaseapp.com",
  projectId: "ingressodahora-9bbe9",
  storageBucket: "ingressodahora-9bbe9.appspot.com",
  messagingSenderId: "714577125190",
  appId: "1:714577125190:web:924365b89faaef94d1cf47",
  measurementId: "G-0BJRH5N9R4"
};



// init firebase
firebase.initializeApp(firebaseConfig);

// init services

//! this give us user info, is authenticated
const auth = firebase.auth();

const signInWithGoogle = ({ setRerender }) => {
  auth
    .signInWithPopup(provider)
    .then(async (result) => {
      var credential = result.credential;
      var token = credential.accessToken;
      var user = result.user;
      const { displayName, email, photoURL } = user;
      // console.log(displayName, email  , photoURL)

      // send an axios request to https://user.ingressodahora.com.br/api/users/create with body of{name, email, token}
      const { data } = await axios.post(
        "https://user.ingressodahora.com.br/api/users/create",
        { name: displayName, email, token }
      );

      if (!data) {
        console.log("error");
      }

      setRerender((prev) => !prev);
    })
    .catch((error) => {
      console.log(error);
    });
};

var provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider, signInWithGoogle };

//! to login
// import { signInWithGoogle } from '../../firebase/config'
// onClick={signInWithGoogle}

//! to logout
// import { auth } from '../firebase/config'
// auth.signOut() ==> onClick
